import { Plus } from "lucide-react"
import { Button } from "@/components/ui/primitives"

type WorkspaceCreateActionProps = {
  label: string
  onClick: () => void
  disabled?: boolean
}

/** Page-level create CTA in the fullscreen toolbar, left of Jobs/Context. Icon-only below md. */
export function WorkspaceCreateAction({ label, onClick, disabled }: WorkspaceCreateActionProps) {
  return (
    <Button
      type="button"
      variant="default"
      size="sm"
      className="h-7 w-7 shrink-0 px-0 md:w-auto md:gap-1.5 md:px-2.5 md:text-[11px]"
      title={label}
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
    >
      <Plus className="h-3.5 w-3.5" />
      <span className="hidden md:inline">{label}</span>
    </Button>
  )
}
